// @ts-check
// src/stores/automations.js — Sesja 3.6 — Automations state in Nanostores

import { atom } from 'nanostores';

/** Lista reguł automatyzacji */
export const $automationRulesList = atom(/** @type {any[]} */ ([]));

/** Lista logów automatyzacji */
export const $automationLogsList = atom(/** @type {any[]} */ ([]));

/** Meta: events, actions, operators, condition_fields, statuses_*, action_types, invoice_series, email_templates */
export const $automationMeta = atom(/** @type {any} */ ({ events: [], actions: [], operators: [] }));

if (typeof window !== 'undefined') {
  /** @type {any} */ (window).__sbStores = Object.assign(/** @type {any} */ (window).__sbStores || {}, {
    $automationRulesList,
    $automationLogsList,
    $automationMeta,
  });
}
